export const useBuildUrl = () => {
  const runtimeConfig = useRuntimeConfig();

  const buildUrl = (path?: string) => {
    if (path == null) {
      return runtimeConfig.public.BASE_URL || '';
    }
    return `${runtimeConfig.public.BASE_URL}${path}`;
  };

  const buildUrlWithEndSlash = (path: string) => {
    return `${runtimeConfig.public.BASE_URL}${removeEndSlash(path)}/`;
  };

  return { buildUrl, buildUrlWithEndSlash };
};
